import { LOCALE, LocaleActionType } from "./types";

export const receiveLocaleSuccess = (locale: any): LocaleActionType => ({
    type: LOCALE.SUCCESS,
    payload: {
        lang: locale,
    },
});
